import Model, { encoders, ID, Integer } from 'src/models/model'
import ItemPackage from 'src/models/package/ItemPackage'
import PriceCard from 'src/models/showing/PriceCard'
import TicketType from 'src/models/showing/TicketType'

export const PRICE_CARD_ITEM_TYPES = {
  PACKAGE: 'Package',
  TICKET: 'Ticket'
}
PRICE_CARD_ITEM_TYPES.ALL = Object.values(PRICE_CARD_ITEM_TYPES)
export default class PriceCardItem extends Model {
  static name = 'PriceCardItem'

  static deletable = true
  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Ticketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        sortable: true,
        required: true
      },

      priceCard: {
        type: PriceCard,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      ticketType: {
        type: TicketType,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      displayOrder: {
        type: Integer,
        required: true,
        default: 100
      },

      hasCustomPrice: {
        type: Boolean,
        default: false
      },

      customPrice: {
        type: Number,
        encode: encoders.cents,
        default: null
      },

      itemPackage: {
        type: ItemPackage,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },

      libraryParentId: {
        type: ID,
        output: true,
        excludeFromDefault: true
      }
    }

    this.computed = {
      type () {
        if (this.itemPackage) {
          return PRICE_CARD_ITEM_TYPES.PACKAGE
        } else {
          return PRICE_CARD_ITEM_TYPES.TICKET
        }
      },
      // Used by SetDisplayOrderDialog
      name () {
        return this.description
      },
      description () {
        if (this.type === PRICE_CARD_ITEM_TYPES.PACKAGE) {
          return this.itemPackage.name
        } else if (!this.hasCustomPrice) {
          return this.ticketType.description
        } else {
          return `${this.ticketType.name} (${this.price})`
        }
      },
      price () {
        if (this.type === PRICE_CARD_ITEM_TYPES.PACKAGE) {
          return null
        } else if (!this.hasCustomPrice || !this.customPrice) {
          return this.i18n.n(this.ticketType.price, 'currency')
        } else {
          return this.i18n.n(this.customPrice, 'currency')
        }
      }
    }
  }
}
